import React, { useEffect, useRef, useState } from 'react';
import { Card, Switch } from 'antd';
import { Line } from '@antv/g2plot';
import styles from './styles/chart-placeholder.module.scss';

const DirectDepositVolumeAndNetInterestIncomeChart = ({ title, data }) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);
    const [showDdsVolume, setShowDdsVolume] = useState(true);
    const [showNetInterestIncome, setShowNetInterestIncome] = useState(true);

    useEffect(() => {
        // Use provided data or fallback to mock data
        const rawData = data || [
            { date: 'January', ddsVolume: 1000, netInterestIncome: 800 },
            { date: 'February', ddsVolume: 3000, netInterestIncome: 1200 },
            { date: 'March', ddsVolume: 1500, netInterestIncome: 900 },
            { date: 'April', ddsVolume: 2500, netInterestIncome: 1100 },
            { date: 'May', ddsVolume: 4500, netInterestIncome: 1400 },
            { date: 'June', ddsVolume: 5500, netInterestIncome: 1600 },
            { date: 'July', ddsVolume: 4500, netInterestIncome: 1300 }
        ];

        // Transform data for chart based on toggle states
        const chartData = [];
        rawData.forEach(item => {
            if (showDdsVolume) {
                chartData.push({
                    date: item.date,
                    type: 'ddsVolume',
                    value: item.ddsVolume
                });
            }
            if (showNetInterestIncome) {
                chartData.push({
                    date: item.date,
                    type: 'netInterestIncome',
                    value: item.netInterestIncome
                });
            }
        });

        if (chartRef.current) {
            // Destroy existing chart instance if it exists
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }

            // Create new chart instance
            chartInstanceRef.current = new Line(chartRef.current, {
                data: chartData,
                xField: 'date',
                yField: 'value',
                seriesField: 'type',
                smooth: true,
                point: {
                    size: 3,
                    shape: 'circle',
                },
                line: {
                    color: ['#1890ff', '#fa8c16'],
                    size: 2,
                },
                tooltip: {
                    formatter: (datum) => {
                        return { name: datum.type === 'ddsVolume' ? 'New DDS Volume' : 'Net Interest Income', value: datum.value ? datum.value.toLocaleString() : '0' };
                    },
                },
                yAxis: {
                    min: 0,
                },
                height: 200,
                width: 550,
                legend: {
                    visible: false, // Hide legend since we have toggles
                },
            });

            chartInstanceRef.current.render();
        }

        // Cleanup function
        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
                chartInstanceRef.current = null;
            }
        };
    }, [data, showDdsVolume, showNetInterestIncome]);

    return (
        <Card className={styles.chartPlaceholder} title={title}>
            <div className={styles.chartContainer}>
                <div className={styles.chartToggles}>
                    <div className={styles.toggleItem}>
                        <span className={styles.toggleLabel}>Net Interest Income</span>
                        <Switch 
                            checked={showNetInterestIncome}
                            onChange={setShowNetInterestIncome}
                            size="small" 
                        />
                    </div>
                    <div className={styles.toggleItem}>
                        <span className={styles.toggleLabel}>New DDS Volume</span>
                        <Switch 
                            checked={showDdsVolume}
                            onChange={setShowDdsVolume}
                            size="small" 
                        />
                    </div>
                </div>
                <div ref={chartRef} />
            </div>
        </Card>
    );
};

export default DirectDepositVolumeAndNetInterestIncomeChart;
